export const pageTitle = 'Omashu'
export const placeholderText = 'Try searching for cabbages, honor, tea, dai li, juice, fire, and more...!'
